module.exports = __webpack_public_path__ + "static/basic-flow_3-e0c92724b8a893f827765e18ef88b7e1.png";